import { ethers } from "ethers";
import abi1 from "./c/GlobalPool.json";
import Web3 from 'web3';

const Buy = ({ state1 }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract1 } = state1;
     const contractABI = abi1.abi1;

    const w1 = document.querySelector("#w1").value;
    const w2 = document.querySelector("#w2").value;
    const w3 = document.querySelector("#w3").value;
    const w4 = document.querySelector("#w4").value;
    
      console.log(w2);
    const web3 = new Web3(Web3.givenProvider);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
   
    const addressOfYourContract = '0x9fcd3fdf76ed9d0f67c390d506546bbdaae6e6d0';
   
    const rt ="150";
      const busdContractAddress = '0xf09a02b39e22EB7D60B17070012297Ee0478a0f1';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;

    function refreshPage() {
      window.location.reload(false);
    }
    
    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    const amountToApprove = ethers.utils.parseUnits('10000', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

     const transaction = await contract1.register1(w1,w2,w3,w4, {
              gasLimit: 1200000,
  });

           await transaction.wait();
          console.log("Transaction is done");
  

    /*
if(pp>0)
{
  //admin
 //admin1
 //admin2
 //admin3
//admin4
//admin5
//admin6

    const transaction = await contract.admin5('0x63d9Adc06CDf01e291dd0D01Fa3Cf3cA6EAAce74','0x63d9Adc06CDf01e291dd0D01Fa3Cf3cA6EAAce74', {
  gasLimit: 360000000,

});
 await transaction.wait();
 console.log("Transaction is done");
 
      // const transaction = await contract.admin4(20, {  
   
  // const transaction = await contract.register(refer,a, {
/* 
}
else
{
  if(a>0)
  {
            const transaction = await contract.register(name,a, {
              gasLimit: 1200000,
  });
           await transaction.wait();
          console.log("Transaction is done");
      }
      }
      */
  refreshPage();
             };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        <input type="hidden" id ="name"></input>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <button
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
    style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Register
    
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy;